import React from "react";

export default function Base({}) {
	return <>
		<path d="M85 0C93.2843 0 100 6.71573 100 15V85C100 93.2843 93.2843 100 85 100H15C6.71573 100 3.2215e-07 93.2843 0 85V15C0 6.71573 6.71573 3.22129e-07 15 0H85ZM25 15C19.4772 15 15 19.4772 15 25V75C15 80.5228 19.4772 85 25 85H75C80.5228 85 85 80.5228 85 75V25C85 19.4772 80.5228 15 75 15H25Z"/>
	</>
}